export class UniqueTeklifNoRequestModel {
    authToken: string;
    sigortaliId: number;
    sigortaliAracId: number;
}
